import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leadership.component';

@Component({
  selector: 'app-leadership-provider',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.scss', '../leadership.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProviderComponent {
  @Input() leadershipMembers: LeadershipMember[] = [];
  @Input() selectedDesign: 'podium' | 'grid' | 'timeline' | 'magazine' | 'minimal' = 'magazine';
  @Input() providersPagination: any = {};
  @Output() loadMore = new EventEmitter<void>();

  get topThree(): LeadershipMember[] {
    return this.leadershipMembers.filter(m => m.rank <= 3).sort((a, b) => a.rank - b.rank);
  }

  loadMoreProviders(): void {
    this.loadMore.emit();
  }
}

